export default class UpdateWebhookRequest {
    name: string = '';
    enabled: boolean = false;
    url: string = '';
}